import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { CompletionRule } from 'app/library/course-offering/enums/completion-rule.enum';
import { AutomaticallyBySetRules } from 'app/library/module/models/automatically-by-set-rules';

@Pipe({
    name: 'getStatusByValue',
})
@Injectable()
export class GetStatusByValuePipe implements PipeTransform {
    transform(statusValue: number, entityStatuses: any, property: string): number {
        if (
            entityStatuses === AutomaticallyBySetRules &&
            (statusValue === CompletionRule.AUTO_ALL_SECTIONS ||
                statusValue === CompletionRule.AUTO_MANDATORY_SECTIONS ||
                statusValue === CompletionRule.AUTO_SPECIFIED_SECTIONS ||
                statusValue === CompletionRule.AUTO_PERCENTAGE_OF_SECTIONS)
        ) {
            statusValue = CompletionRule.SECTIONS;
        }

        if (statusValue === undefined || statusValue === null) {
            return null;
        }

        const entityStatus = entityStatuses.all.find((status) => status.value === statusValue);

        if (!entityStatus) {
            return statusValue;
        }

        return entityStatus[property];
    }
}
